import Grid from "@mui/material/Grid2"

export default function GridItem({fullWidth = false, children, ...props}) {
  return (
    <Grid size={{ xs: 12, md: fullWidth ? 12 : 6 }} {...props}>
      {children}
    </Grid>
  )
}
